import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(private)/profile')({
	beforeLoad: () => {
		throw redirect({ to: '/account' })
	}
})
